import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { ICmsBlock } from '@icms/core/resource/block/icms-block';
import { ICmsBlockResource } from '@icms/core/resource/block/icms-block.resource';
import { NFirstMissionIntroduction } from './first-mission-introduction.component';

@Injectable({ providedIn: 'root' })
export class FirstMissionIntroductionResolver implements Resolve<void | ICmsBlock<NFirstMissionIntroduction.IBlockData>> {
    constructor(private iCmsBlockResource: ICmsBlockResource) {}
    resolve(): Promise<any> {
        return this.iCmsBlockResource.retrieve({ bareUrl: NFirstMissionIntroduction.componentId }, undefined);
    }
}
